export default __webpack_public_path__ + "static/media/oferecemos.0487fff2.jpg";